import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { APIService } from 'src/app/services/APIService/api.service';
import { MrTranslatePipe } from '../../pipes/mr-translate.pipe';
import { KostenListeComponent } from './kostenliste/kostenliste.component';
import { AuftragsListeComponent } from './auftragsliste/auftragsliste.component';

import { ClarityModule } from '@clr/angular';
import { toSignal } from '@angular/core/rxjs-interop';
import { BasicStoreService } from 'src/app/services/BasicStore/basic-store.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-auftraege',
  templateUrl: './auftraege.component.html',
  styleUrls: ['./auftraege.component.scss'],
  imports: [ClarityModule, KostenListeComponent, AuftragsListeComponent, MrTranslatePipe],
})
export class AuftraegeComponent {
  private readonly apiservice = inject(APIService);
  private readonly basicStore = inject(BasicStoreService);

  private readonly rechte = toSignal<{ AllowPAuftrGen: boolean; AllowPAuftrRueck: boolean }>(
    this.apiservice.AuftragWFStatus({ mode: 'GETROLES' })
  );
  protected readonly isGenehmiger = computed(() => this.rechte()?.AllowPAuftrGen);
  protected readonly isRueckmelder = computed(() => this.rechte()?.AllowPAuftrRueck);

  protected reloadTabs() {
    this.basicStore.reloadTabs();
  }
}
